// skintype
const Listskintype = () => import('@/views/setting/skin-type')
const Formskintype = () => import('@/views/setting/skin-type/form')

export default {
    path: 'skin-type',
    redirect: '/skin-type',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'skin-type',
            component: Listskintype,
            meta: {
                link: 'skin-type',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Skin Type', active: true },
                ],
                pageTitle: 'Skin Type'
            }
        },
        {
            path: 'add',
            name: 'addskintype',
            component: Formskintype,
            meta: {
                link: 'skin-type',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Skin Type', url: '/skin-type' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Skin Type'
            }
        },
        {
            path: 'edit/:id',
            name: 'editskintype',
            component: Formskintype,
            meta: {
                link: 'skin-type',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Skin Type', url: '/skin-type' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Skin Type'
            }
        },
    ]
}